export enum SliderArrow {
  INSIDE = 0,
  OUTSIDE = 1,
  CUSTOM = 2,
}

export type SliderWithOutsideArrows = {
  type: SliderArrow.OUTSIDE;
  componentLeft?: React.ReactNode;
  componentRight?: React.ReactNode;
  dark?: boolean;
  visibleForMobile?: boolean;
};

export type SliderWithInsideArrows = {
  type: SliderArrow.INSIDE;
  insetLeftArrow?: string;
  insetRightArrow?: string;
  visibleForMobile?: boolean;
};

export type SliderWithCustomArrows = {
  type: SliderArrow.CUSTOM;
  componentLeft: React.ReactNode;
  componentRight: React.ReactNode;
};

export interface ScArrowProps {
  hide?: boolean;
  isActive?: boolean;
  visibleForMob?: boolean;
  inset?: string;
}

export type SliderWithArrowProps =
  | SliderWithInsideArrows
  | SliderWithOutsideArrows
  | SliderWithCustomArrows;

interface GridParams {
  cols?: number;
  rows?: number;
}

interface Breakpoints<T> {
  desktopL?: T;
  desktop?: T;
  tablet?: T;
  mobile?: T;
  mobileS?: T;
  mobileXS?: T;
}

export interface SlideGrid extends Breakpoints<GridParams> {}
